module.exports = __webpack_public_path__ + "img/MET.57581032.png";